import React, { useState } from 'react';
import {
  func, string, oneOf, shape, number
} from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Overlay } from '@thd-olt-component-react/overlay';
import { useReviewPhotos } from '@thd-nucleus/data-sources';
import { useReviewPhotosDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { Carousel } from '@thd-olt-component-react/carousel';
import { CustomerImageOverlay } from '@thd-olt-component-react/customer-image-overlay';
import { dataModel } from './ratings-and-reviews-data-model';
import * as analytics from '../../analytics';
import './customer-image-carousel.scss';

const analyticsData = (element) => {
  analytics.track('click', {
    element: 'media'
  });
};

export const CustomerImageCarousel = ({
  minimumNumberOfImages, itemId, channel, tooltip, hasPhotos
}) => {
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [imageId, setImageId] = useState(null);
  const { data, error, loading } = useReviewPhotosDeprecated({ itemId, ssr: false });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const { reviewPhotos } = data || {};
  const { Results } = reviewPhotos || {};
  if (!(Results || []).length) {
    hasPhotos();
    return null;
  }

  const carouselPhotos = Results.reduce((images, review) => {
    return images.concat(review.Photos);
  }, []);

  const imgOverlayPhotoId = carouselPhotos[imageId]?.Id;

  const onCarouselClick = (id) => {
    setImageId(id.toString());
    if (tooltip) {
      tooltip.hide();
    }
    analyticsData();
    setOverlayOpen(true);
  };
  if (carouselPhotos.length <= minimumNumberOfImages) {
    hasPhotos();
    return null;
  }
  return (
    <>
      <div className="product-details__secondary">
        <h3 className="product-details__secondary__heading">Customer Images</h3>
      </div>
      <div className="zone-customer-images">
        <Col xs={12}>
          <Carousel
            multiItem
            className="zone-customer-images__tooltip-carousel"
            showDots={false}
            onClickItem={(itemIndex) => setImageId(itemIndex)}
            selectedItem={imageId}
            itemWidthDesktop="40px"
          >
            {
              carouselPhotos.map((photo, photoIndex) => {
                const thumbNailImg = photo.Sizes ? `url(${photo.Sizes.thumbnail.Url})` : '';
                return (
                  <div
                    key={`${photoIndex}`}
                    className="zone-customer-images__tooltip-carousel__carousel-normal"
                  >
                    <button
                      aria-label="img"
                      type="button"
                      style={{
                        backgroundImage: (thumbNailImg)
                      }}
                      onClick={() => onCarouselClick(photo.Id)}
                    />
                  </div>
                );
              })
            }
          </Carousel>
        </Col>
        <Overlay medium open={overlayOpen} onClose={() => setOverlayOpen(false)}>
          {overlayOpen && imgOverlayPhotoId ? (
            <CustomerImageOverlay
              channel={channel}
              photos={reviewPhotos}
              selectedPhotoID={imgOverlayPhotoId}
              onClose={() => {
                setOverlayOpen(false);
                setImageId(null);
              }}
              loopPhotos={false}
              onInteraction={analyticsData}
            />
          ) : null}
        </Overlay>
      </div>
    </>
  );
};

CustomerImageCarousel.displayName = 'CustomerImageCarousel';

CustomerImageCarousel.propTypes = {
  channel: oneOf(['desktop', 'mobile']),
  itemId: string.isRequired,
  minimumNumberOfImages: number,
  tooltip: shape({}),
  hasPhotos: func.isRequired,
};

CustomerImageCarousel.defaultProps = {
  channel: 'desktop',
  minimumNumberOfImages: 3,
  tooltip: {},
};

CustomerImageCarousel.dataModel = {
  reviewPhotos: dataModel?.reviewPhotos
};
